import type { CRegisterationToNewslettersTranslations } from "./pl";

export const de: CRegisterationToNewslettersTranslations = {
  noConfig: "Keine Formularkonfigurationsdaten.",
  noCategorys: "Es gibt keine Newsletter-Kategorien, die Sie abonnieren können.",

  topInfo: "Wir laden Sie ein, unseren Newsletter zu abonnieren.",
  topInfo2: "Zu welchen Themen möchten Sie Informationen erhalten?",
  categoriesHeader: "Newsletter-Kategorien",
  additionalDataHeader: "Abonnentendaten",
  loggedInIntro: (email: string) =>
    email
      ? `Sie legen Newsletter-Kategorien für Ihr Konto (${email}) fest - nicht für die zuvor eingegebene Adresse. Wählen Sie aus, welche Sie erhalten möchten.`
      : "Verwalten Sie die Abonnements Ihres Kontos - wählen Sie die Kategorien aus, die Sie erhalten möchten.",
  save: "Anmelden",
  saveLoggedIn: "Abonnements aktualisieren",
  saving: "Speichern...",
  emailLabel: "E-Mail",

  validation: {
    requiredField: (label: string) => `Das Feld "${label}" ist erforderlich.`,
    selectCategory: "Bitte wählen Sie mindestens eine Kategorie aus.",
    invalidEmail: "Ungültige E-Mail-Adresse.",
    notAcceptedRegulamin: "Geschäftsbedingungen nicht akzeptiert.",
    notAcceptedPersonalData: "Sie müssen der Verarbeitung Ihrer personenbezogenen Daten zustimmen.",
    notAcceptedMarketing: "Es wurde keine Zustimmung zum Versand erteilt.",
  },

  status: {
    waitBeforeSubmit: (seconds: number) =>
      `Bitte warten Sie noch ${seconds} Sekunden vor dem Absenden.`,
    rateLimit: "Zu viele Versuche von dieser IP-Adresse. Versuchen Sie es gleich erneut.",
    subscribeFailed: "Anmeldung zum Newsletter fehlgeschlagen.",
    subscribeSuccess: "Sie wurden für den Newsletter angemeldet, vielen Dank!",
    updateSuccess: "Ihre Abonnements wurden aktualisiert.",
    networkError: (message: string) => `Netzwerkfehler: ${message}`,
    networkErrorGeneric: "Netzwerkfehler beim Speichern.",
  },
};
